import { AssignmentAction } from "@apaq/orgkit-js";

export class AssignmentActionFormatter {
  public static format(action: AssignmentAction): string {
    switch(action) {
      case 'None':
        return $localize`Planned`;
      case 'Skipped':
        return $localize`Skipped`;
      case 'InProgress':
        return $localize`In progress`;
      case 'Completed':
        return $localize`Completed`;   
      default:
        return '-';          
    }
  }
}